window.scrollPromoLeft = scrollPromoLeft;
window.scrollPromoRight = scrollPromoRight;
export function showModalPromo() {
    const modal = document.getElementById('modalPromo');
    if (modal) {
        modal.classList.remove('hidden');
    }
}

export function hideModalPromo() {
    const modal = document.getElementById('modalPromo');
    if (modal) {
        modal.classList.add('hidden');
    }
}

export function scrollPromoLeft() {
    const container = document.getElementById('promoScrollContainer');
    if (container) container.scrollBy({ left: -300, behavior: 'smooth' });
}

export function scrollPromoRight() {
    const container = document.getElementById('promoScrollContainer');
    if (container) container.scrollBy({ left: 300, behavior: 'smooth' });
}
